import { useState } from "react";
import { Cookie } from "lucide-react";
import { Button } from "@/components/ui/button";
import { getConsent, setConsent } from "@/lib/analytics";

export default function CookieConsent() {
  const [choice, setChoice] = useState(() => getConsent());

  if (choice) return null;

  const decide = (value) => {
    setConsent(value);
    setChoice(value);
  };

  return (
    <div
      data-testid="cookie-banner"
      role="dialog"
      aria-label="Consentement aux cookies de mesure"
      className="fixed bottom-0 left-0 right-0 z-[60] p-4 md:p-6 animate-fade-up"
    >
      <div className="mx-auto max-w-3xl rounded-xl border border-slate-200 bg-white/95 backdrop-blur-xl p-5 shadow-lg md:flex md:items-center md:gap-6">
        <div className="flex gap-3">
          <Cookie className="h-5 w-5 text-blue-600 shrink-0 mt-0.5" />
          <p className="text-sm text-slate-600 leading-relaxed">
            Nous utilisons une mesure d'audience (Google Analytics) pour comprendre l'usage de
            l'application. Elle n'est activée qu'avec votre accord et aucune donnée de votre carnet
            d'entretien n'est transmise.
          </p>
        </div>
        <div className="mt-4 md:mt-0 flex items-center gap-2 shrink-0">
          <Button
            variant="outline"
            onClick={() => decide("denied")}
            data-testid="cookie-refuse-btn"
            className="rounded-full border-slate-200"
          >
            Refuser
          </Button>
          <Button
            onClick={() => decide("granted")}
            data-testid="cookie-accept-btn"
            className="rounded-full bg-blue-600 hover:bg-blue-700"
          >
            Accepter
          </Button>
        </div>
      </div>
    </div>
  );
}
